import { gql } from '@apollo/client';
import TASK_FRAGMENT from './TaskFragment.graphql';

const TASK_CREATE = gql`
  mutation TaskCreate($input: TaskCreateInput!) {
    taskCreate(input: $input) {
      task {
        __typename
        ...TaskFragment
      }
      errors {
        error
        message
      }
    }
  }
  ${TASK_FRAGMENT}
`;

export default TASK_CREATE;
